import { FAILURE, IDLE, REQUEST, SUCCESS } from 'src/redux/constants';
import { DELETE_IMAGES_SURVEYS } from './constants';
import { ThunkAction } from 'redux-thunk';
import { State } from 'src/redux/reducer';
import { DeleteImagesSurveysDataActionTypes } from './types';
import api from 'src/utils/api';
import { addImageDelete } from '../addImages/actions';

export const loadDeleteImagesSurveys =
  (
    id: number,
  ): ThunkAction<
    Promise<void>,
    State,
    null,
    DeleteImagesSurveysDataActionTypes
  > =>
  async (dispatch: any) => {
    dispatch({ type: DELETE_IMAGES_SURVEYS + REQUEST });
    try {
      const payload = await api.loadDeleteImagesSurveys(id);
      dispatch({ type: DELETE_IMAGES_SURVEYS + SUCCESS, payload });
      dispatch(addImageDelete(id));
    } catch (error) {
      dispatch({ type: DELETE_IMAGES_SURVEYS + FAILURE, error });
    }
  };

export const deleteImageIdle = () => ({ type: DELETE_IMAGES_SURVEYS + IDLE });
